"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyOemManufacturersUseEvermark() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="why-oem-manufacturers-use-evermark" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold font-default mb-8">
            Why Do OEM Manufacturers Use Evermark?
          </h2>
          
          <div className="space-y-6 text-lg leading-relaxed font-default">
            <p>
              An OEM applies the same nameplates and data plates to every unit it builds — and the marking has to be identical every time, available on the production schedule, and correct in every detail of ratings, serials, and branding. A marking supplier that drifts on format, runs late, or can't scale with volume becomes a line-down risk.
            </p>
            
            <p>
              Evermark Industrial Solutions runs OEM marking as a program, not a series of one-off orders. Evermark holds the approved layout, material, and serialization logic, and reorders produce identical nameplates, data plates, and direct part marks — so the marking on unit one thousand matches unit one.
            </p>
            
            <p>
              Evermark Industrial Solutions produces the full OEM marking set from one source — equipment and data-plate nameplates, serialized direct part marking, and asset or model/branding plates — in phenolic, stainless, anodized aluminum, or brass, matched to the product and its environment.
            </p>
          </div>
        </div>
      </div>
    </section>;
}